import * as array from './utils.array';
import * as color from './utils.color';
import * as date from './utils.date';
import * as document from './utils.document';
import * as icons from './utils.icons';
import * as image from './utils.image';
import * as file from './utils.files';
import * as misc from './utils.misc';
import * as object from './utils.object';
import * as regexp from './utils.regexp';
import * as string from './utils.string';
import * as time from './utils.time';
import { initTinyMCEOptions } from './utils.tinymce';
import { htmlDecodeSpecialChars } from './utils.html';

export const Utils = {
    array,
    color,
    date,
    document,
    file,
    icons,
    image,
    misc,
    object,
    regexp,
    string,
    time,
    tinymce: { initTinyMCEOptions },
    html: { htmlDecodeSpecialChars },
};
